import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getNewsList } from '@/API/apiService';

interface NewsItem {
  id: number;
  date: string; // "2025.02.03" のような日付表記
  title: string;
  title_en: string;
  url: string;
  tag?: {
    id: number;
    name: string;
    name_en?: string;
  };
}

export const News: React.FC = () => {
  const location = useLocation();
  // URL の先頭セグメントを取得し、'en'なら英語、それ以外は日本語とする
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  const [newsData, setNewsData] = useState<NewsItem[]>([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await getNewsList();
        // response.data.data に NewsItem の配列が入っている前提
        setNewsData(response.data.data);
      } catch (err) {
        console.error('Failed to fetch news data:', err);
      }
    })();
  }, []);

  const visibleNews = showAll ? newsData : newsData.slice(0, 6);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="pb-[50px] text-center text-lg">
        {useEnglish ? '(NEWS)' : '(お知らせ)'}
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {visibleNews.map((newsItem) => (
          <div key={newsItem.id} className="mb-6 text-sm">
            <span className="block">{newsItem.date}</span>
            <a
              href={newsItem.url}
              className="text-black block text-sm"
              target="_blank"
              rel="noopener noreferrer"
            >
              {useEnglish ? newsItem.title_en : newsItem.title}
            </a>
            {newsItem.tag && (
              <div className="text-left bg-gray-200 text-black mt-1 inline-block text-xs underline text-[12px]">
                {useEnglish && newsItem.tag.name_en
                  ? newsItem.tag.name_en
                  : newsItem.tag.name}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="md:flex md:justify-center">
        {!showAll && newsData.length > 6 && (
          <button
            onClick={() => setShowAll(true)}
            className="underline mt-4 text-base"
          >
            View More
          </button>
        )}
      </div>
    </div>
  );
};
